import { get } from '..';
import { applySolveAnalyticsFilters, GetSolveAnalyticsStatsProps } from './Utils';

const GetSLAViolationsByLocation = (props: GetSolveAnalyticsStatsProps) => {
  const baseUrl: string = 'solve-analytics/sla-violations-by-location';
  const url: string = applySolveAnalyticsFilters(baseUrl, props);
  return get(url);
};

export default GetSLAViolationsByLocation;
